import React from "react";

import { string, func, bool } from "prop-types";

import { TextFieldGroup, Button, Loading } from "../../../../common";

const ContactPostcode = ({
  memberPostcode,
  handleChange,
  loading,
  canFindAddress,
  getMatchedAddress,
}) => {
  const handleKeyPress = (e) => {
    if (e.charCode === 13 && canFindAddress) {
      return getMatchedAddress(e);
    }
    return () => {};
  };

  return (
    <div>
      <label htmlFor="postcode">Postcode</label>
      <div className="input-group">
        <TextFieldGroup
          classes="register_field form-control"
          value={memberPostcode}
          onChange={(e) => {
            handleChange("postcode", e.target.value);
          }}
          placeholder="e.g. ME14 1AJ"
          onKeyPress={(e) => handleKeyPress(e)}
        />

        <Button
          classes="btn btn-outline-info text-dark ml-1"
          onClick={canFindAddress ? getMatchedAddress : () => {}}
        >
          {loading ? <Loading /> : "Find address"}
        </Button>
      </div>
    </div>
  );
};

ContactPostcode.propTypes = {
  memberPostcode: string.isRequired,
  handleChange: func.isRequired,
  loading: bool,
  canFindAddress: bool.isRequired,
  getMatchedAddress: func.isRequired,
};

export default ContactPostcode;
